import { Component } from 'react'
import scriptjs from 'scriptjs'

export default class GoogleMapsComponent extends Component {
  state = {
    googleMaps: null,
  };

  componentDidMount() {
    if (typeof window.google === 'undefined') {
      window.gMapsLoaded = function() {
        scriptjs.done('google-maps-places')
      };

      let apiKey = window.googlePlacesApiKey;
      scriptjs('https://maps.googleapis.com/maps/api/js?key=' + apiKey + '&libraries=places&callback=gMapsLoaded');
      scriptjs.ready('google-maps-places', () => {
        this.handleLoaded(window.google.maps)
      });
    } else {
      this.handleLoaded(window.google.maps)
    }
  }

  handleLoaded(googleMaps) {
    this.setState({ googleMaps });
    if (this.handleApiLoaded) {
      this.handleApiLoaded(googleMaps);
    }
  }

  render() {
    return null;
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/GoogleMapsComponent/index.js
 **/